<template>
  <a-card :bordered="false">

    <a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            class="form">
      <a-card class="card" title="公司基本信息" :bordered="false">
        <div slot="extra">
          <a-button @click="goBack" style="margin-right:15px;"><a-icon type="unordered-list" /> 返回</a-button>
        </div>
      </a-card>
      <a-card class="card" title="基础信息" :bordered="false">
        <a-row class="form-row" :gutter="16">
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-model-item ref="name" prop="name" label="名称">
              <a-input
                      placeholder="请输入名称"
                      v-model="form.name"
                      :disabled="show == 1 ? true : false"
                      @blur="
          () => {
            $refs.name.onFieldBlur();
          }
        "
              />
            </a-form-model-item>
          </a-col>

          <a-col :lg="6" :md="12" :sm="24">
            <a-form-model-item ref="relax" prop="relax" label="联系人">
              <a-input
                      placeholder="请输入联系人姓名"
                      :maxLength="11"
                      v-model="form.relax"
                      :disabled="show == 1 ? true : false"
                      @blur="
          () => {
            $refs.relax.onFieldBlur();
          }
        "
              />
            </a-form-model-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-model-item ref="phone" prop="phone" label="电话">
              <a-input
                      placeholder="请输入联系方式"
                      :maxLength="11"
                      v-model="form.phone"
                      :disabled="show == 1 ? true : false"
                      @blur="
          () => {
            $refs.phone.onFieldBlur();
          }
        "
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">


          <a-col :lg="6" :md="12" :sm="24">
            <a-form-model-item label="所属行政区划">
              <a-cascader :options="optionAreas"
                          v-model="areaIds"
                          :showSearch="showSearch"
                          @change="areaChange"
                          placeholder="请选择"
                          expandTrigger="hover"/>
            </a-form-model-item>
          </a-col>

          <a-col :lg="6" :md="12" :sm="24">
            <a-form-model-item ref="address" prop="address" label="地址">
              <a-input
                      placeholder="请输入地址"
                      :maxLength="11"
                      v-model="form.address"
                      :disabled="show == 1 ? true : false"
                      @blur="
          () => {
            $refs.address.onFieldBlur();
          }
        "
              />
            </a-form-model-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-model-item label="公司类型">
              <a-select placeholder="请选择" v-model="form.privil">
                <a-select-option
                        :value="item.value"
                        v-for="item in userList"
                        :key="item.value"
                >{{ item.desc }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>


        </a-row>

      </a-card>
      <a-form-item v-if="showSubmit" style="margin-top:15px; margin-left:25px;">
        <a-button type="primary" style="margin-right:20px;" @click="onSubmit">提交</a-button>
        <a-button style="margin-right:0px; background-color:#f30; color:#fff; border-color:#f30" @click="onDelete" v-if="id != 0">删除</a-button>
      </a-form-item>
    </a-form-model>


  </a-card>
</template>

<script>
import { addComp, compInfo, updateComp,deleteComp } from "@/api/comp/comp";

import { getAreaTree } from '@/api/area/index'

export default {
  data() {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 8 },
      other: "",
      showSubmit: true,
      form: {
        name: "",
        logo: "",
        relax: "",
        phone: "",
        areaId: undefined,
        areaName: "",
        address: "",
        privil: 0,

      },


      areaIds: [0,0,0],
      optionAreas: [
        {
          value: '1',
          label: '北京市'
        }
      ],


      showSearch: {
        filter: (inputValue, path) => {
          return path.some(option => {
                    // label搜索
                    return fullText(inputValue, option.label);
                  }
          )
        },
        matchInputWidth: true
      },

      id: 0,
      show: 0,

      trueList: [
        {value: 0,desc: '否'},
        {value: 1,desc: '是'}
      ],
      userList: [
        {value: 0,desc: '总公司'},
        {value: 1,desc: '分公司'},
        {value: 2,desc: '经销商'}
      ],
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
        privil: [{ required: true, message: "请输入选择公司类型", trigger: "blur" }]

      }
    };
  },
  created() {

    var areaId = localStorage.getItem("userAreaId")
    // 获取当前账号信息
    this.areaId = 0
    // 获取区划列表
    this.getAreaTree()

    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      compInfo({
        id: this.id
      }).then(res => {
        console.log(res);
        if (res.code == 0) {
          this.form = res.data;

          this.getAreaIds();

          console.log(this.areaIds)
        }
        console.log(this.form);
      });
    }
    if (this.$route.query.show) {
      this.show = this.$route.query.show;
    }
  },
  methods: {
    getAreaIds () {
      var mfind = false;
      if(this.optionAreas != null && this.optionAreas.length > 0)
      {
        for(let i=0;i<this.optionAreas.length;i++)
        {
          if(this.optionAreas[i].value == this.form.areaId)
          {
            this.areaIds = [this.optionAreas[i].value,this.optionAreas[i].value]
            mfind = true;
            break;
          }
          else if(this.optionAreas[i].children!=null && this.optionAreas[i].children.length > 0)
          {
            for(let j=0;j<this.optionAreas[i].children.length;j++)
            {
              if(this.optionAreas[i].children[j].value == this.form.areaId)
              {
                this.areaIds = [this.optionAreas[i].value,this.optionAreas[i].children[j].value,this.optionAreas[i].children[j].value]

                mfind = true;
                break;
              }
              else  if(this.optionAreas[i].children[j].children!=null && this.optionAreas[i].children[j].children.length > 0)
              {
                for(let k=0;k<this.optionAreas[i].children[j].children.length;k++) {
                  if (this.optionAreas[i].children[j].children[k].value == this.form.areaId) {
                    this.areaIds = [this.optionAreas[i].value, this.optionAreas[i].children[j].value, this.optionAreas[i].children[j].children[k].value]

                    mfind = true;
                    break;
                  }
                }
              }
              if(mfind)
                break;

            }
            if(mfind)
              break;
          }
        }
      }


    },

    areaChange (value) {
      this.form.areaId = value[value.length - 1]
      var mfind = false;
      //获取名称
      for(let i=0;i<this.optionAreas.length;i++)
      {
        if(this.optionAreas[i].value == this.form.areaId)
        {
          this.form.areaName = this.optionAreas[i].label
          mfind = true;
          break;
        }
        else if(this.optionAreas[i].children!=null && this.optionAreas[i].children.length > 0)
        {
          for(let j=0;j<this.optionAreas[i].children.length;j++)
          {
            if(this.optionAreas[i].children[j].value == this.form.areaId)
            {
              this.form.areaName = this.optionAreas[i].children[j].label
              mfind = true;
              break;
            }
            else  if(this.optionAreas[i].children[j].children!=null && this.optionAreas[i].children[j].children.length > 0)
            {
              for(let k=0;k<this.optionAreas[i].children[j].children.length;k++) {
                if (this.optionAreas[i].children[j].children[k].value == this.form.areaId) {

                  this.form.areaName = this.optionAreas[i].children[j].children[k].label
                  mfind = true;
                  break;
                }
              }
            }
            if(mfind)
              break;
          }
          if(mfind)
            break;
        }
      }

    },
    getAreaTree () {
      getAreaTree({areaId:this.areaId}).then(response => {
        this.optionAreas = response.data

        this.getAreaIds();

      })
    },
    onDelete () {
      var self = this
      this.$confirm({
        title: '确认删除',
        content: `是否确认删除当前信息？`,
        cancelText: '取消',
        okText: '确定',
        okType: 'danger',
        onOk () {
          return new Promise((resolve, reject) => {
            deleteComp({ id: self.id }).then(response => {
              self.$message.error('删除成功')
              self.goBack()
            }).catch((e) => {
              // self.$message.error('删除成功')
            }).finally(() => {
              resolve()
            })
          })
        }
      })
    },
    goBack () {
      this.$router.back()
    },
    onSubmit() {

      this.$refs.ruleForm.validate(valid => {

        if (this.form.phone && !/^1[3456789]\d{9}$/.test(this.form.phone)) {
          this.$message.error("请输入正确的手机号");
          return;
        }
        if (valid) {
          var self = this
          this.$confirm({
            title: '确认提交',
            content: `确认提交公司信息？`,
            cancelText: '取消',
            okText: '确定',
            okType: 'danger',
            onOk () {
              return new Promise((resolve, reject) => {

                if (self.id) {
                  self.updateComp();
                } else {
                  self.addComp();
                }

                resolve()

              })
            }
          })

        } else {
          console.log("error submit!!");
          return false;
        }
      });

    },
    addComp() {
      let _this = this;

      if (this.form.phone && !/^1[3456789]\d{9}$/.test(this.form.phone)) {
        this.$message.error("请输入正确的手机号");
        return;
      }

      if(this.form.areaId == null || this.form.areaId == 0){
        this.$message.error("请选择所属行政区");
        return;
      }

      addComp({

        name: _this.form.name,
        logo: _this.form.logo,
        relax: _this.form.relax,
        phone: _this.form.phone,
        privil: _this.form.privil,
        address: _this.form.address,
        areaId: _this.form.areaId,
        areaName: _this.form.areaName,
        status: 0
      }).then(res => {
        console.log(res);
        if (res.code == 0) {
          _this.$message.success("新增成功", function() {
            _this.$router.push({ path: "/index/edit/complist" });
          });
        } else {
          _this.$message.error(res.message);
        }
      });
    },
    updateComp() {
      let _this = this;
      let data = {
        id: _this.id,

        name: _this.form.name,
        logo: _this.form.logo,
        relax: _this.form.relax,
        phone: _this.form.phone,
        privil: _this.form.privil,
        address: _this.form.address,
        areaId: _this.form.areaId,
        areaName: _this.form.areaName,

      };

      updateComp(data).then(res => {
        console.log(res);
        if (res.code == 0) {
          _this.$message.success("编辑成功", function() {
            _this.$router.push({ path: "/index/edit/complist" });
          });
        } else {
          _this.$message.error(res.message);
        }
      });
    },


  }
};
</script>

<style lang="less" scoped>
  .card{
    margin-bottom: 24px;
  }
</style>
